import { render } from "./ProductDetail_SmartAuditRisk.vue?vue&type=template&id=50ee8d8c&scoped=true"
import script from "./ProductDetail_SmartAuditRisk.vue?vue&type=script&lang=js"
export * from "./ProductDetail_SmartAuditRisk.vue?vue&type=script&lang=js"

import "./ProductDetail_SmartAuditRisk.vue?vue&type=style&index=0&id=50ee8d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ee8d8c"]])

export default __exports__